"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "vallo-di-nera": {
    "d9c1877e": [{
      "hkey": "8c4cd721",
      "slug": "vallo-di-nera",
      "name": "Vallo di Nera",
      "primary": true,
      "skipSearch": false
    }],
    "borbonea": [{
      "hkey": "8c4cd721",
      "slug": "vallo-di-nera",
      "name": "Vallo di Nera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7c8347b6": [{
      "hkey": "8c4cd721",
      "slug": "vallo-di-nera",
      "name": "Vallo di Nera",
      "primary": true,
      "skipSearch": false
    }],
    "la-pieve": [{
      "hkey": "8c4cd721",
      "slug": "vallo-di-nera",
      "name": "Vallo di Nera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6e9b7deb": [{
      "hkey": "8c4cd721",
      "slug": "vallo-di-nera",
      "name": "Vallo di Nera",
      "primary": true,
      "skipSearch": false
    }],
    "le-campore": [{
      "hkey": "8c4cd721",
      "slug": "vallo-di-nera",
      "name": "Vallo di Nera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "559ed1a5": [{
      "hkey": "8c4cd721",
      "slug": "vallo-di-nera",
      "name": "Vallo di Nera",
      "primary": true,
      "skipSearch": false
    }],
    "roccagelli": [{
      "hkey": "8c4cd721",
      "slug": "vallo-di-nera",
      "name": "Vallo di Nera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;